/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  chooseProvider: {
    defaultMessage: 'Choose your bank',
    id: 'ChooseProvider.chooseProvider',
  },
  selectYourBank: {
    defaultMessage: 'Select your bank',
    id: 'ChooseProvider.selectYourBank',
  },
  noProviders: {
    defaultMessage: 'No banks were found.',
    id: 'ProvidersList.noProviders',
  },
  multibanking: {
    defaultMessage:
      'More than one bank? Connect these in a later step to get the most suitable offer.',
    id: 'ProvidersList.multibanking',
  },
  connected: {
    defaultMessage: 'Connected',
    id: 'ProvidersList.connected',
  },
  previouslyConnected: {
    defaultMessage: 'Previously connected',
    id: 'ProvidersList.previouslyConnnected',
  },
  mostCommon: {
    defaultMessage: 'Most common',
    id: 'ProvidersList.mostCommon',
  },
  allBanks: {
    defaultMessage: 'All banks',
    id: 'ProvidersList.allBanks',
  },
  allOtherBanks: {
    defaultMessage: 'All other banks',
    id: 'ProvidersList.allOtherBanks',
  },
  cantFindYourBank: {
    defaultMessage: "Can't find your bank? Try search",
    id: 'ProvidersList.cantFindYourBank',
  },
});
